var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBooting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    transform: "translate(-2808 -525.61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 16,
    height: 16,
    transform: "translate(2824 541.61) rotate(-180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M2812.156,530.326a5.057,5.057,0,0,1,7.126-.609l.012-.673a.68.68,0,0,1,1.36.025l-.047,2.68a.682.682,0,0,1-.68.669.657.657,0,0,1-.108-.009l-2.521-.4a.681.681,0,0,1,.214-1.344l.963.153a3.693,3.693,0,1,0,1,4.074.68.68,0,1,1,1.273.481,5.056,5.056,0,1,1-8.595-5.046Z",
    fill: "#ffc430",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBooting);
export default __webpack_public_path__ + "static/media/icon-booting.80ec3302550e4d20d14d464908068901.svg";
export { ForwardRef as ReactComponent };